// RouteGuard — wraps the protected role-prefixed shell.
//
// Responsibilities:
//   1. Wait for AuthContext to finish hydrating (`loading`)
//   2. If no user → redirect to /login (preserving intended destination)
//   3. If user's role doesn't match the route's required role → bounce to *their* home
//
// Wrong-role bouncing matters: an `employee` who deep-links into /super-admin/users
// gets sent back to /employee/dashboard instead of seeing a 404 or (worse) a UI
// that lets them try forbidden actions. Backend RBAC still enforces all of this
// independently — this guard is only about UX.

import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth, rolePrefix } from '../../lib/AuthContext';

export default function RouteGuard({ role, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#faf9f5]">
        <div className="flex items-center gap-3 text-[#162a52]">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span className="text-sm font-medium">Loading…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/portal-x7k3" replace state={{ from: location }} />;
  }

  if (user.role !== role) {
    return <Navigate to={`${rolePrefix(user.role)}/dashboard`} replace />;
  }

  return children;
}
